import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { addDays, startOfWeek, format, subWeeks, addWeeks } from "date-fns";
import Api from "../Api";
import axios from "axios";
import { BASE_API_URL } from "../const";

const GetEPG = () => {
  const [responseListChannels, setResponseListChannels] = useState();
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [responseAPI, setResponseAPI] = useState();
  const [editedData, setEditedData] = useState();
  const [selectedDay, setSelectedDay] = useState(null);

  const daysOfWeek = Array.from({ length: 7 }, (_, i) =>
    format(
      addDays(startOfWeek(currentWeek, { weekStartsOn: 1 }), i),
      "yyyy-MM-dd"
    )
  );

  useEffect(() => {
    getDataListChannels();
  }, []);

  useEffect(() => {
    if (responseAPI) {
      setEditedData(responseAPI.map((item) => ({ ...item }))); // Создаем копию данных
    }
  }, [responseAPI]);

  async function getDataListChannels() {
    try {
      const response = await axios.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }
  const handlePreviousWeek = () => {
    setCurrentWeek((prev) => subWeeks(prev, 1));
  };
  const getNextMonday = () => {
    // Если selectedDay не определён, используем текущую дату
    const referenceDate = selectedDay || new Date();
    const nextMonday = startOfWeek(addWeeks(referenceDate, 1), {
      weekStartsOn: 1,
    }); // Получаем дату следующего понедельника
    return format(nextMonday, "yyyy-MM-dd"); // Форматируем дату
  };
  const handleNextWeek = () => {
    setCurrentWeek((prev) => addWeeks(prev, 1));
    if (!selectedChannel) return;
    const nextMondayDate = getNextMonday();
    setSelectedDay(nextMondayDate);
    fetchProgramData(selectedChannel, nextMondayDate);
  };

  const handleRowClick = (element) => {
    setSelectedChannel(element.id);
    // You can add other actions here, such as opening a modal or navigating to another page
  };
  // Функция для обработки нажатия на кнопку с днем
  const handleDateButtonClick = (date) => {
    if (!selectedChannel) return; // Проверка на наличие выбранного канала
    setSelectedDay(date);
    fetchProgramData(selectedChannel, date);
  };

  // Функция для GET-запроса с использованием выбранного канала и даты
  async function fetchProgramData(channelId, date) {
    try {
      const response = await axios.post(`${BASE_API_URL}/api/met`, {
        channel_id: channelId,
        date: date,
      });
      setResponseAPI(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleMetUidChange = (index, newUid) => {
    setEditedData((prevData) =>
      prevData.map((item, idx) =>
        idx === index ? { ...item, met_uid: newUid } : item
      )
    );
  };

  // Обработчик для подтверждения изменений
  const handleConfirmClick = (index) => {
    const updatedMetUid = editedData[index]?.met_uid;
    console.log("Confirmed met_uid:", updatedMetUid);
    // Здесь добавьте логику для сохранения обновленного met_uid
    setMetUid(editedData[index].movie_id, updatedMetUid);
  };

  async function setMetUid(id, newMetUid) {
    Api.post(`${BASE_API_URL}/api/movie/met/${id}`, {
      met_uid: newMetUid,
    })
      .then((response) => {
        console.log("transfer ok");
      })
      .catch((error) => {
        console.log("transfer bad");
      });
  }
  const handleDelete = (start) => {
    console.log("Deleting item with start time:", start);
    console.log("Channel id: " + selectedChannel);
    // Здесь добавьте логику для удаления элемента из editedData или выполнения API-запроса
  };

  return (
    <>
      {responseListChannels && responseListChannels.length > 0 && (
        <Box>
          {/* Заголовок */}
          <Box
            sx={{
              backgroundColor: "#E0F7FA",
              padding: 2,
              borderRadius: "8px 8px 0 0",
            }}
          >
            <Typography variant="h5" align="center" color="primary">
              EPG
            </Typography>
          </Box>

          <Box sx={{ display: "flex", height: "100%" }}>
            {/* Левая часть с каналами */}
            <Box sx={{ width: "25%", padding: 2 }}>
              <TableContainer component={Paper}>
                <Table
                  sx={{
                    "& .MuiTableCell-root": {
                      padding: "6px 8px", // Уменьшаем отступы
                    },
                  }}
                >
                  <TableBody sx={{ border: "1px solid #ddd" }}>
                    {responseListChannels
                      .filter((element) => element.visible_menu === 1)
                      .map((element, index) => (
                        <TableRow
                          key={index}
                          onClick={() => handleRowClick(element)}
                          sx={{
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f0f0f0" },
                          }}
                        >
                          <TableCell
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            {element.name}
                            {selectedChannel === element.id && (
                              <CheckIcon
                                sx={{
                                  color: "green",
                                  fontSize: 20, // Large size for the checkmark
                                  marginLeft: 1,
                                }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Правая часть */}
            <Box sx={{ width: "75%", padding: 2 }}>
              {/* Кнопки с датами */}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "center",
                  marginBottom: 2,
                }}
              >
                {daysOfWeek.map((day, index) => (
                  <Button
                    key={index}
                    variant="contained"
                    color={selectedDay === day ? "secondary" : "primary"}
                    onClick={() => handleDateButtonClick(day)}
                  >
                    {day}
                  </Button>
                ))}
              </Box>

              {/* Кнопки для переключения недель */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  marginBottom: 2,
                }}
              >
                <Button variant="outlined" onClick={handlePreviousWeek}>
                  Предыдущая неделя
                </Button>
                <Button variant="outlined" onClick={handleNextWeek}>
                  Следующая неделя
                </Button>
              </Box>

              {/* Таблица с расписанием */}
              <TableContainer
                component={Paper}
                sx={{ width: "60%", margin: "0 auto", marginTop: 4 }}
              >
                {editedData && (
                  <Table
                    sx={{
                      height: "20px", // Установите желаемую высоту
                      "& td, & th": { padding: "8px" }, // Корректировка отступов для ячеек
                    }}
                  >
                    <TableBody>
                      {editedData.map((item, index) => (
                        <TableRow key={index}>
                          {/* Первая колонка с датой dt_start */}
                          <TableCell sx={{ width: "150px" }}>
                            {item.dt_start}
                          </TableCell>

                          {/* Вторая колонка с ссылкой и заголовком subtitle */}
                          <TableCell
                            sx={{
                              maxWidth: 250,
                              minWidth: 250,
                              width: 250,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <a
                              href={item.met_uid}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.subtitle}
                            </a>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default GetEPG;
